import { create, all } from 'mathjs'

import isBeforeDate from './isBeforeDate.js'
import isAfterDate from './isAfterDate.js'
import isSameOrBeforeDate from './isSameOrBeforeDate.js'
import isSameOrAfterDate from './isSameOrAfterDate.js'
import isSameDate from './isSameDate.js'
import contains from './contains.js'

const math = create(all)

math.import({
  isBeforeDate,
  isAfterDate,
  isSameOrBeforeDate,
  isSameOrAfterDate,
  isSameDate,
  contains,
})

export default math
